import { generateAboutURL } from "../../../src/services/url";
import {
  CURRENCY,
  LOGO_URL,
  ACCCOUNT_FEES,
  EVENT_HANDLERS,
  LOCATION,
} from "../../constants";
import { LAYOUT_TYPE } from './Banner'
import {
  getInstallment,
  getTitles,
  isPromotionLengthValid,
  createQueryString,
} from "./utils";

export const SingleLineInversed = ({
  merchantId = "",
  currency = CURRENCY.AUD,
  containerClass = "",
  price,
  paymentOption,
  promotionMonths,
  productName,
  allowPriceBreakdown,
  defaultWidget,
}) => {
  const logoURL = LOGO_URL[currency];
  const accountFees = ACCCOUNT_FEES[currency];
  const { amount, length } = getInstallment(price, promotionMonths);

  const aboutURL = generateAboutURL(
    merchantId,
    currency,
    createQueryString(
      paymentOption,
      price,
      promotionMonths,
      allowPriceBreakdown,
      productName,
      LOCATION.WIDGET
    )
  );

  const { ONELINE_TITLE } = getTitles({
    length,
    amount,
    price,
    currency,
    aboutURL,
    defaultWidget,
    layout : LAYOUT_TYPE.SINGLE_LINE_INVERSED
  });

  //same as standard
  //only differences are: 
  //this one always use the One line title
  //this one doesn't take into account allowPriceBreakdown
  const title = ONELINE_TITLE

  return `
  <!-- Latitude Interest Free Snippet - Start -->
  <div
    style="font-size: 14px; margin: 10px 0px; font-weight:450; display: flex; flex-wrap: wrap; align-items: center; max-width:420px"
    class="${containerClass}">
      <img
        style="${currency === "AUD" ? `height:16px;` : `height:18px;`} margin: 0 12px 0 0;"
        src="${logoURL}"
        alt="logo-${currency}"
      />
      ${title}
      <span
        style="white-space:nowrap;" 
      >
        <a
          id="lat-find-out"
          style="text-decoration:underline; cursor:pointer; color:inherit; margin-left: 12px;"
          target="_blank"
          onclick="${EVENT_HANDLERS.LEARN_MORE_CLICK}('${aboutURL}')"
        >
         Learn more
        </a>
      </span>
  </div>
  <!-- Latitude Interest Free Snippet - End -->
  `;
};
